// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Peer_wrapper__2hdGl","photoWrapper":"Peer_photoWrapper__31Clv","avatar":"Peer_avatar__1oMI8","crossIcon":"Peer_crossIcon__3GQ1I","name":"Peer_name__1Xl_i"};